export default "__VITE_ASSET__CAVGuIaN__"